import "../MainDashboard.scss";
import CommaSeparator from "../../../../../Utils/CommaSeparator";

const MyOrders = ({
  totalPurchaseAmount,
  numberOfPurchases,
  numberOfComments,
}) => {
  return (
    <div className="main-my-order">
      <div className="single-box" style={{ background: "#FFB410" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="82"
          height="82"
          fill="none"
          viewBox="0 0 82 82"
        >
          <g clipPath="url(#clip0_1318_7234)">
            <g filter="url(#filter0_d_1318_7234)">
              <g filter="url(#filter1_d_1318_7234)">
                <path
                  fill="url(#paint0_linear_1318_7234)"
                  d="M20.5 21.14a5.125 5.125 0 015.125-5.124h41a5.125 5.125 0 015.125 5.125v28.187a5.125 5.125 0 01-5.125 5.125h-41a5.125 5.125 0 01-5.125-5.125V21.141z"
                ></path>
              </g>
            </g>
            <g filter="url(#filter2_di_1318_7234)">
              <path
                fill="#fff"
                d="M36.5 63.769c-1.294 0-2.513-.657-3.375-1.8l-2.813-3.75c-.056-.075-.28-.169-.375-.188H29c-7.819 0-12.656-2.118-12.656-12.656V36c0-8.288 4.368-12.656 12.656-12.656h15c8.288 0 12.656 4.368 12.656 12.656v9.375c0 8.288-4.368 12.656-12.656 12.656h-.938a.49.49 0 00-.374.188l-2.813 3.75c-.862 1.143-2.081 1.8-3.375 1.8zM29 26.156c-6.712 0-9.844 3.132-9.844 9.844v9.375c0 8.475 2.907 9.844 9.844 9.844h.938c.956 0 2.043.544 2.625 1.312l2.812 3.75c.656.863 1.594.863 2.25 0l2.813-3.75a3.285 3.285 0 012.624-1.312H44c6.712 0 9.844-3.132 9.844-9.844V36c0-6.712-3.132-9.844-9.844-9.844H29z"
              ></path>
            </g>
            <g filter="url(#filter3_di_1318_7234)">
              <path
                fill="#fff"
                d="M36.5 43.5a1.869 1.869 0 01-1.875-1.875A1.88 1.88 0 0136.5 39.75a1.88 1.88 0 011.875 1.875A1.869 1.869 0 0136.5 43.5z"
              ></path>
            </g>
            <g filter="url(#filter4_di_1318_7234)">
              <path
                fill="#fff"
                d="M44 43.5a1.869 1.869 0 01-1.875-1.875A1.88 1.88 0 0144 39.75a1.88 1.88 0 011.875 1.875A1.869 1.869 0 0144 43.5z"
              ></path>
            </g>
            <g filter="url(#filter5_di_1318_7234)">
              <path
                fill="#fff"
                d="M29 43.5a1.869 1.869 0 01-1.875-1.875A1.88 1.88 0 0129 39.75a1.88 1.88 0 011.875 1.875A1.869 1.869 0 0129 43.5z"
              ></path>
            </g>
          </g>
          <defs>
            <filter
              id="filter0_d_1318_7234"
              width="67.25"
              height="54.438"
              x="16.5"
              y="12.016"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dx="4" dy="4"></feOffset>
              <feGaussianBlur stdDeviation="4"></feGaussianBlur>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 0.627451 0 0 0 0 0.0705882 0 0 0 0.4 0"></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1318_7234"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_1318_7234"
                result="shape"
              ></feBlend>
            </filter>
            <filter
              id="filter1_d_1318_7234"
              width="67.25"
              height="54.438"
              x="12.5"
              y="8.016"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset></feOffset>
              <feGaussianBlur stdDeviation="4"></feGaussianBlur>
              <feComposite in2="hardAlpha" operator="out"></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1318_7234"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_1318_7234"
                result="shape"
              ></feBlend>
            </filter>
            <filter
              id="filter2_di_1318_7234"
              width="56.313"
              height="56.425"
              x="8.344"
              y="19.344"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy="4"></feOffset>
              <feGaussianBlur stdDeviation="4"></feGaussianBlur>
              <feComposite in2="hardAlpha" operator="out"></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1318_7234"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_1318_7234"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset></feOffset>
              <feGaussianBlur stdDeviation="2"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect2_innerShadow_1318_7234"
              ></feBlend>
            </filter>
            <filter
              id="filter3_di_1318_7234"
              width="19.75"
              height="19.75"
              x="26.625"
              y="35.75"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy="4"></feOffset>
              <feGaussianBlur stdDeviation="4"></feGaussianBlur>
              <feComposite in2="hardAlpha" operator="out"></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1318_7234"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_1318_7234"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset></feOffset>
              <feGaussianBlur stdDeviation="2"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect2_innerShadow_1318_7234"
              ></feBlend>
            </filter>
            <filter
              id="filter4_di_1318_7234"
              width="19.75"
              height="19.75"
              x="34.125"
              y="35.75"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy="4"></feOffset>
              <feGaussianBlur stdDeviation="4"></feGaussianBlur>
              <feComposite in2="hardAlpha" operator="out"></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1318_7234"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_1318_7234"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset></feOffset>
              <feGaussianBlur stdDeviation="2"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect2_innerShadow_1318_7234"
              ></feBlend>
            </filter>
            <filter
              id="filter5_di_1318_7234"
              width="19.75"
              height="19.75"
              x="19.125"
              y="35.75"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy="4"></feOffset>
              <feGaussianBlur stdDeviation="4"></feGaussianBlur>
              <feComposite in2="hardAlpha" operator="out"></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1318_7234"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_1318_7234"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset></feOffset>
              <feGaussianBlur stdDeviation="2"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect2_innerShadow_1318_7234"
              ></feBlend>
            </filter>
            <linearGradient
              id="paint0_linear_1318_7234"
              x1="46.125"
              x2="46.125"
              y1="16.016"
              y2="54.453"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFBC0E"></stop>
              <stop offset="1" stopColor="#FF7C1E"></stop>
            </linearGradient>
            <clipPath id="clip0_1318_7234">
              <path fill="#fff" d="M0 0H82V82H0z"></path>
            </clipPath>
          </defs>
        </svg>
        <div className="text-side">
          <h5>{numberOfComments}</h5>
          <p> تعداد نظرات</p>
        </div>
      </div>

      <div className="single-box" style={{ background: "#70D074" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="82"
          height="82"
          fill="none"
          viewBox="0 0 82 82"
        >
          <g clipPath="url(#clip0_1318_7248)">
            <g filter="url(#filter0_d_1318_7248)">
              <g filter="url(#filter1_d_1318_7248)">
                <path
                  fill="url(#paint0_linear_1318_7248)"
                  d="M20.5 21.14a5.125 5.125 0 015.125-5.124h41a5.125 5.125 0 015.125 5.125v28.187a5.125 5.125 0 01-5.125 5.125h-41a5.125 5.125 0 01-5.125-5.125V21.141z"
                ></path>
              </g>
            </g>
            <g fill="#fff" filter="url(#filter2_di_1318_7248)">
              <path d="M41.258 35.286c-.743 0-1.36-.658-1.36-1.451v-2.67c0-2.031-.816-4.005-2.231-5.378-1.434-1.393-3.284-2.032-5.243-1.838-3.265.329-6.131 3.888-6.131 7.603v1.877c0 .793-.617 1.45-1.361 1.45s-1.36-.657-1.36-1.45v-1.897c0-5.204 3.936-10.002 8.598-10.485 2.721-.271 5.333.638 7.329 2.592 1.977 1.916 3.12 4.663 3.12 7.526v2.67c0 .793-.617 1.45-1.36 1.45z"></path>
              <path d="M38.183 61H27.058c-8.566 0-10.16-3.963-10.568-7.816L15.1 42.143c-.204-1.99-.278-4.848 1.668-6.986 1.669-1.844 4.431-2.728 8.436-2.728h14.833c4.023 0 6.786.903 8.436 2.728 1.928 2.138 1.872 4.995 1.668 6.949l-1.39 11.078C48.343 57.037 46.748 61 38.183 61zM25.204 35.194c-3.133 0-5.284.608-6.378 1.825-.908.995-1.205 2.525-.964 4.81l1.39 11.042c.316 2.95 1.132 5.383 7.806 5.383h11.125c6.674 0 7.49-2.415 7.805-5.346l1.39-11.078c.242-2.25-.055-3.78-.963-4.793-1.094-1.235-3.245-1.843-6.378-1.843H25.204z"></path>
              <path d="M38.829 42.905A1.914 1.914 0 0136.905 41a1.91 1.91 0 011.904-1.905A1.91 1.91 0 0140.715 41a1.894 1.894 0 01-1.885 1.905zM26.448 42.905A1.914 1.914 0 0124.524 41a1.91 1.91 0 011.905-1.905A1.91 1.91 0 0128.333 41a1.894 1.894 0 01-1.885 1.905z"></path>
            </g>
          </g>
          <defs>
            <filter
              id="filter0_d_1318_7248"
              width="67.25"
              height="54.438"
              x="16.5"
              y="12.016"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dx="4" dy="4"></feOffset>
              <feGaussianBlur stdDeviation="4"></feGaussianBlur>
              <feColorMatrix values="0 0 0 0 0.525269 0 0 0 0 0.9175 0 0 0 0 0.536919 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1318_7248"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_1318_7248"
                result="shape"
              ></feBlend>
            </filter>
            <filter
              id="filter1_d_1318_7248"
              width="67.25"
              height="54.438"
              x="12.5"
              y="8.016"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset></feOffset>
              <feGaussianBlur stdDeviation="4"></feGaussianBlur>
              <feComposite in2="hardAlpha" operator="out"></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1318_7248"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_1318_7248"
                result="shape"
              ></feBlend>
            </filter>
            <filter
              id="filter2_di_1318_7248"
              width="51.238"
              height="56"
              x="7"
              y="17"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy="4"></feOffset>
              <feGaussianBlur stdDeviation="4"></feGaussianBlur>
              <feComposite in2="hardAlpha" operator="out"></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1318_7248"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_1318_7248"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset></feOffset>
              <feGaussianBlur stdDeviation="2"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect2_innerShadow_1318_7248"
              ></feBlend>
            </filter>
            <linearGradient
              id="paint0_linear_1318_7248"
              x1="46.125"
              x2="46.125"
              y1="16.016"
              y2="54.453"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#76D37A"></stop>
              <stop offset="1" stopColor="#5DD661"></stop>
            </linearGradient>
            <clipPath id="clip0_1318_7248">
              <path fill="#fff" d="M0 0H82V82H0z"></path>
            </clipPath>
          </defs>
        </svg>
        <div className="text-side">
          <h5>{numberOfPurchases}</h5>
          <p>خرید</p>
        </div>
      </div>

      <div className="single-box" style={{ background: "#FD8891" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="82"
          height="82"
          fill="none"
          viewBox="0 0 82 82"
        >
          <g clipPath="url(#clip0_1318_7260)">
            <g filter="url(#filter0_d_1318_7260)">
              <g filter="url(#filter1_d_1318_7260)">
                <path
                  fill="url(#paint0_linear_1318_7260)"
                  d="M20.5 21.14a5.125 5.125 0 015.125-5.124h41a5.125 5.125 0 015.125 5.125v28.187a5.125 5.125 0 01-5.125 5.125h-41a5.125 5.125 0 01-5.125-5.125V21.141z"
                ></path>
              </g>
            </g>
            <g fill="#fff" filter="url(#filter2_di_1318_7260)">
              <path d="M42.206 58.5H23.159c-1.127 0-2.188-.109-3.142-.326-.498-.065-1.105-.238-1.733-.477C15.402 56.614 12 53.95 12 47.319V36.16C12 29.074 16.074 25 23.16 25h19.046c5.98 0 9.837 2.86 10.877 8.06.195.954.282 1.972.282 3.1v11.159c0 7.128-4.052 11.18-11.16 11.18zM23.18 28.293c-5.33 0-7.91 2.578-7.91 7.909v11.159c0 3.878 1.366 6.262 4.161 7.324.434.151.845.26 1.235.325.824.173 1.625.26 2.514.26h19.046c5.33 0 7.91-2.579 7.91-7.91V36.204c0-.91-.066-1.712-.217-2.449-.737-3.684-3.25-5.46-7.693-5.46H23.181z"></path>
              <path d="M48.71 65H29.664c-1.842 0-3.489-.26-4.897-.802-3.186-1.191-5.266-3.705-5.98-7.302a1.602 1.602 0 01.454-1.473c.39-.39.954-.542 1.495-.412.715.152 1.517.238 2.427.238H42.21c5.33 0 7.909-2.578 7.909-7.909V36.181c0-.91-.065-1.712-.217-2.448a1.666 1.666 0 01.434-1.474c.39-.39.931-.563 1.473-.433 5.2 1.062 8.06 4.919 8.06 10.856V53.84c0 7.107-4.051 11.16-11.159 11.16zm-25.937-6.5c.694 1.256 1.734 2.145 3.164 2.665 1.04.39 2.297.585 3.748.585h19.047c5.33 0 7.909-2.578 7.909-7.909v-11.16c0-3.423-1.062-5.698-3.25-6.89v11.55c0 7.085-4.074 11.158-11.16 11.158H22.773z"></path>
              <path d="M32.694 49.117a7.352 7.352 0 01-7.346-7.345 7.352 7.352 0 017.346-7.346 7.352 7.352 0 017.345 7.346 7.352 7.352 0 01-7.345 7.345zm0-11.44a4.106 4.106 0 00-4.096 4.095 4.106 4.106 0 004.096 4.095 4.106 4.106 0 004.095-4.095 4.106 4.106 0 00-4.095-4.096zM20.303 48.164a1.637 1.637 0 01-1.625-1.626v-9.534c0-.888.737-1.625 1.625-1.625.889 0 1.625.737 1.625 1.625v9.535c0 .888-.715 1.625-1.625 1.625zM45.07 48.164a1.637 1.637 0 01-1.625-1.626v-9.534c0-.888.736-1.625 1.625-1.625.888 0 1.625.737 1.625 1.625v9.535c0 .888-.715 1.625-1.625 1.625z"></path>
            </g>
          </g>
          <defs>
            <filter
              id="filter0_d_1318_7260"
              width="67.25"
              height="54.438"
              x="16.5"
              y="12.016"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dx="4" dy="4"></feOffset>
              <feGaussianBlur stdDeviation="4"></feGaussianBlur>
              <feColorMatrix values="0 0 0 0 0.937255 0 0 0 0 0.415686 0 0 0 0 0.498039 0 0 0 0.5 0"></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1318_7260"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_1318_7260"
                result="shape"
              ></feBlend>
            </filter>
            <filter
              id="filter1_d_1318_7260"
              width="67.25"
              height="54.438"
              x="12.5"
              y="8.016"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset></feOffset>
              <feGaussianBlur stdDeviation="4"></feGaussianBlur>
              <feComposite in2="hardAlpha" operator="out"></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1318_7260"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_1318_7260"
                result="shape"
              ></feBlend>
            </filter>
            <filter
              id="filter2_di_1318_7260"
              width="63.87"
              height="56"
              x="4"
              y="21"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy="4"></feOffset>
              <feGaussianBlur stdDeviation="4"></feGaussianBlur>
              <feComposite in2="hardAlpha" operator="out"></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1318_7260"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_1318_7260"
                result="shape"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset></feOffset>
              <feGaussianBlur stdDeviation="2"></feGaussianBlur>
              <feComposite
                in2="hardAlpha"
                k2="-1"
                k3="1"
                operator="arithmetic"
              ></feComposite>
              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix>
              <feBlend
                in2="shape"
                result="effect2_innerShadow_1318_7260"
              ></feBlend>
            </filter>
            <linearGradient
              id="paint0_linear_1318_7260"
              x1="46.125"
              x2="46.125"
              y1="16.016"
              y2="54.453"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FD8891"></stop>
              <stop offset="1" stopColor="#F07F7F"></stop>
            </linearGradient>
            <clipPath id="clip0_1318_7260">
              <path fill="#fff" d="M0 0H82V82H0z"></path>
            </clipPath>
          </defs>
        </svg>
        <div className="text-side">
          <h5>{CommaSeparator(totalPurchaseAmount)}</h5>
          <p>مبلغ خرید</p>
        </div>
      </div>
    </div>
  );
};

export default MyOrders;
